import { OrgUserPrivate, OrgUserRef, UserPrivate } from "@/viaduct-api";
import Keycloak, { KeycloakProfile } from "keycloak-js";

import { createContext, useContext } from "react";

interface AuthContextType {
  keycloak?: Keycloak;
  initialized: boolean;
  authenticated: boolean;
  authenticating: boolean;
  keycloakProfile?: KeycloakProfile;
  fetchingUser: boolean;
  user?: UserPrivate;
  orgUser?: OrgUserPrivate;
  logout: () => Promise<void>;
  login: () => Promise<void>;
  switchOrg: (orgUser: OrgUserRef) => Promise<void>;
  getToken: () => Promise<string | null>;
}

export const AuthContext = createContext<AuthContextType>({
  keycloak: undefined,
  initialized: false,
  authenticated: false,
  authenticating: false,
  fetchingUser: false,
  logout: () => Promise.resolve(),
  login: () => Promise.resolve(),
  switchOrg: () => Promise.resolve(),
  getToken: () => Promise.resolve(null),
});

export const useAuth = () => useContext(AuthContext);
